import React from "react";

/**
 * AddButton component for adding new annotations
 * Used for Time Signature, Key, and Tempo changes
 */
const AddButton = ({ onClick }) => {
  return (
    <button 
      onClick={onClick}
      className="w-8 h-8 flex items-center justify-center bg-black rounded-full text-white hover:bg-gray-800"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
      </svg>
    </button>
  );
};

export default AddButton;
